export default __webpack_public_path__ + "static/media/3 - Просветительские фотовыставки.f6d77405.jpeg";